<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    :outlined="!$vuetify.breakpoint.xs"
    :flat="!$vuetify.breakpoint.xs"
    :solo="true"
  ></v-select>
</template>

<script>
export default {
  name: "BaseSelect"
};
</script>
